import React from "react";
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

const advantages = [
  { titleKey: "about.advantages.1.title", textKey: "about.advantages.1.text" },
  { titleKey: "about.advantages.2.title", textKey: "about.advantages.2.text" },
  { titleKey: "about.advantages.3.title", textKey: "about.advantages.3.text" },
  { titleKey: "about.advantages.4.title", textKey: "about.advantages.4.text" },
  { titleKey: "about.advantages.5.title", textKey: "about.advantages.5.text" },
  { titleKey: "about.advantages.6.title", textKey: "about.advantages.6.text" },
];

function PlatformAdvantages() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      <div className="mx-auto max-w-[1220px] px-[20px] xl:px-0">
        {/* Title */}
        <Fade bottom>
        <div className="flex flex-col items-center gap-[15px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4] xl:text-[32px]">
            {t("about.advantages.title")}
          </h2>
          <span className="block h-[4px] w-[104px] bg-[#05193a]" />
        </div>
        </Fade>

        {/* Grid desktop 3-col / mobile 2-col */}
        <Fade bottom delay={200}>
        <div className="mt-[40px] grid grid-cols-2 border-l border-t border-[#d3d3d3] xl:grid-cols-3">
          {advantages.map((item, i) => (
            <div
              key={i}
              className="border-b border-r border-[#d3d3d3] px-[8px] py-[18px] xl:px-[26px] xl:py-[30px]"
            >
              <p className="font-['Nunito_Sans'] text-[21px] font-black leading-[1.5] text-[#05193a] xl:text-[32px]">
                {t(item.titleKey)}
              </p>
              <p className="mt-[4px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.4] text-[#05193a] xl:text-[16px]">
                {t(item.textKey)}
              </p>
            </div>
          ))}
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default PlatformAdvantages;
